/** Assignment statuses that still occupy the one-open-row slot. */
export const COLLECTION_OPEN_SLOT_STATUSES = Object.freeze(['open', 'awaiting_approval']);

/**
 * Next assignment status from contribution counts.
 * Adding records never closes the task. The assignee submits with
 * `canCompleteCollectionAssignment`. Completed and cancelled never move backward.
 *
 * @param {{ status?: string, pending?: number }} input
 * @returns {'open'|'awaiting_approval'|'completed'|'cancelled'}
 */
export function nextCollectionAssignmentStatus({
    status = 'open',
    pending = 0,
} = {}) {
    if (status === 'cancelled' || status === 'completed') return status;
    if (Number(pending) > 0) return 'awaiting_approval';
    return 'open';
}

/**
 * Whether the assignee may submit the task.
 * Unlimited tasks need at least one settled record. A quota is a minimum, not an auto-close.
 *
 * @param {{ unlimited?: boolean, minCount?: number|null, settled?: number, pending?: number }} input
 * @returns {{ ok: boolean, reason?: 'pending'|'short', need: number }}
 */
export function canCompleteCollectionAssignment({
    unlimited = false,
    minCount = 1,
    settled = 0,
    pending = 0,
} = {}) {
    const need = unlimited ? 1 : Math.max(1, Number(minCount) || 1);
    if (Number(pending) > 0) return { ok: false, reason: 'pending', need };
    if (Number(settled) < need) return { ok: false, reason: 'short', need };
    return { ok: true, need };
}
